import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { Button, Card } from "react-bootstrap";
import { Loading } from "../../Components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { MaintenanceRecordForm } from "../../Components/MaintenanceRecords/MaintenanceRecordForm";
import { Error404 } from "../Errors/Error404";

const EditMaintenanceRecord = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  let { maintenanceRecordId } = useParams();
  const [vendors, setVendors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [approvedBy, setApprovedBy] = useState({});
  const [confirmedBy, setConfirmedBy] = useState({});
  const [vehiclePart, setVehiclePart] = useState({});
  const [maintenanceType, setMaintenanceType] = useState([]);
  const [maintenanceItems, setMaintenanceItems] = useState([]);
  const [maintenanceRecord, setMaintenanceRecord] = useState({});
  const [employeeWithVehicle, setEmployeeWithVehicle] = useState([]);

  useEffect(() => {
    setFetching(true);
    const getEditDetails = async () => {
      try {
        const response = await get(`maintenance/${maintenanceRecordId}/edit`);
        setVendors(response.data.vendors);
        setVehicles(response.data.vehicle);
        setApprovedBy(response.data.approve_by);
        setConfirmedBy(response.data.confirmed_by);
        setVehiclePart(response.data.vehicle_part);
        setMaintenanceType(response.data.maintenance_type);
        setMaintenanceRecord(response.data.maintenanceRecords);
        setMaintenanceItems(response.data.maintenanceRecords.maintenance_items);
        setEmployeeWithVehicle(response.data.employee_with_vehicles);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getEditDetails();
  }, []);

  return (
    <>
      <Card className="container">
        {!fetching && maintenanceRecord?.status !== "awaiting approval" && (
          <Error404 />
        )}

        {!!fetching && (<Loading />)}

        {!fetching && maintenanceRecord?.status === "awaiting approval" &&  (
          <>
            <Card.Header className="d-flex justify-content-between mt-0 mb-4">
              <Card.Title>
                <div className="row">
                  <div className="col-md-12">
                    <h1 className="page-title">Maintenance Record</h1>
                  </div>
                </div>
              </Card.Title>

              <div className="row">
                <div className="col-md-12">
                  <Button onClick={() => navigate(-1)}>Back</Button>
                </div>
              </div>
            </Card.Header>

            <Card.Body>
              <MaintenanceRecordForm
                vendors={vendors}
                vehicles={vehicles}
                approvedBy={approvedBy}
                confirmedBy={confirmedBy}
                vehiclePart={vehiclePart}
                maintenanceType={maintenanceType}
                editMaintenanceItems={maintenanceItems}
                employeeWithVehicle={employeeWithVehicle}
                editMaintenanceRecord={maintenanceRecord}
              />
            </Card.Body>
          </>
        )}
      </Card>
    </>
  );
};

export default EditMaintenanceRecord;
